import { PROVIDER } from 'Pods/ThreeDStudio/Store/constants'

export const PROVIDER_LABELS = {
  [PROVIDER.TENCENT]: 'Hunyuan',
  [PROVIDER.MESHY]: 'Meshy',
  [PROVIDER.TRIPO3D]: 'Tripo3D',
  [PROVIDER.HYPER3D]: 'Hyper3D',
}
